<template>
    <div class="row mt-2">
        <div class="col-12">
            <div class="title">Humidité/Façades</div>
            <table class="table table-nowrap table-centered mb-0 table-slim">
                <tbody>
                    <tr>
                        <td><b>Type de mur</b></td>
                        <td>{{ content.facade.wallType }}</td>
                        <td><b>Couleur de tuile</b></td>
                        <td>{{ content.facade.wallThickness }}</td>
                    </tr>
                    <tr>
                        <td><b>Type de revêtement</b></td>
                        <td>{{ content.facade.coveringType }}</td>
                        <td><b>Couleur</b></td>
                        <td>{{ content.facade.coveringColor }}</td>
                    </tr>
                    <tr>
                        <td><b>Couleur injecteur</b></td>
                        <td>{{ content.facade.injectorColor }}</td>
                        <td><b>Échaufaudage</b></td>
                        <td>{{ content.facade.scaffolding }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WorksheetToiture',
        props: ['content']
    }
</script>

<style lang="scss" scoped>
    .color-FP {
        $color: #354E85;

        .section--bordered, table, .small-square {
            border: 1px solid $color;
        }
    }

    .color-MP {
        $color: #0078B3;

        .section--bordered, table, .small-square {
            border: 1px solid $color;
        }
    }

    .color-3M {
        $color: #70B632;

        .section--bordered, table, .small-square {
            border: 1px solid $color;
        }
    }

    .color-PH {
        $color: #AE0C21;

        .section--bordered, table, .small-square {
            border: 1px solid $color;
        }
    }
    
    .title, td {
        color: black;
        line-height: 1.5;
    }

    .title {
        font-weight: bold;
    }
</style>